import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'

import loader from '../images/loader.gif';
import { useNavigate } from "react-router-dom";
import { Link as RouterLink, } from 'react-router-dom';
import { KeyboardArrowLeftRounded, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { BaseURL } from '../common/URLs';
import Scrollbar from '../common/common-sidebar/components/scrollbar/Scrollbar';
import { Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, Divider, Fab, FormControl, Grid, IconButton, InputLabel, List, ListItem, MenuItem, Select, Stack, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material'
import WorklogListnew from '../HelpDeskAndGrievance/sections/@dashboard/requests/Worklist';
import useResponsive from '../common/common-sidebar/hooks/useResponsive';
import abeplLogo from "../images/abeplLogo.png";
// import Footer from '../common/common-sidebar/layouts/dashboard/footer';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { Container, Row, Col } from 'react-bootstrap';
import { HELPDESK_ROLES } from '../common/constants';
import { idToken } from '../App';
import { getLocalStorageItem } from '../common/localStorageUtils';
import { FAQIcon } from '../common/icons';
import apiClient from '../axios';

function FaqsPage() {
  const [managefaqdata, setmanagefaqdata] = useState([]);
  const [managefaqdatapdf, setmanagefaqdatapdf] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const auth = 'Bearer ' + getLocalStorageItem('id_token');
  const pdfdata = [...managefaqdatapdf]
  const rows = [...managefaqdata];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
  const navigate = useNavigate();
  const isDesktop = useResponsive('up', 'lg');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const logo = (
    <Box
      component="img"
      src={abeplLogo} alt="logo" loading='lazy'
      sx={{ width: 40, height: 40 }}
    />
  );


  const managefaqpdf = () => {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getAllHelpdeskFrequentAskQuestion",


    ).then((response) => {
      if (localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive) {
        let data = response.data.filter(item => item.extFlag === 1);
        setmanagefaqdatapdf(data)
      }
      else {
        let data = response.data.filter(item => item.extFlag === 0);
        setmanagefaqdatapdf(data)
      }
      setLoading(false)
      // console.log(respData, "responseData");


    }).catch((error) => {
      console.log("Error - " + error);
    })
  }


  const managefaq = () => {
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getAllFAQBaseOnCategory",
      {},
      {
        headers: {
          "Authorization": auth,
          "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0
        },
      }
    ).then((response) => {
      let alldata = response.data;
      let tempArr = [];
      for (let i = 0; i < alldata.length; i++) {
        let tempObj = alldata[i];
        let tempNewArr = [];
        for (let j = 0; j < tempObj.fAQListPojo.length; j++) {
          if (tempObj.fAQListPojo[j].faqSubCatPojo.length > 0) {
            tempObj.fAQListPojo[j].catData = tempObj;

            tempNewArr.push(tempObj.fAQListPojo[j]);
            //console.log(tempNewArr,'checkinggggggggggggggggggggggggggggggg');
          }

        }
        tempArr.push(...tempNewArr)
      }
      alldata = tempArr;
      setmanagefaqdata(alldata);
      setLoading(false)

    }).catch((error) => {
      console.log("Error - " + error);
    })
  }
  useEffect(() => {
    managefaq()
    managefaqpdf()
  }, [])

  const MyDoc = () => {
    const doc = new jsPDF()

    //  var img = new Image()
    //  img.src = 'assets/logo.png'
    doc.addImage(abeplLogo, 'png', 85, 3, 20, 20, 'logo')
    // doc.addField('Assam Bio Ethanol Private Limited, ABEPL')

    autoTable(doc, { html: '#my-table' })

    //doc.addImage(abeplLogo);
    // Or use javascript directly:
    autoTable(doc, {

      head: [['Catagory', 'Sub-catagory', 'FAQ', 'FAQA']],
      body: [
        ...pdfdata.map((row) => [row.grievanceCategory, row.grevanceSubCategory, row.fqaQuestion, row.fqaAnswer])



      ],
    })

    doc.save('ABEPL_FAQs.pdf')


  }


  return (
    <>
      <Helmet>
        <title> FAQs | ABEPL </title>
      </Helmet>
      {
        (isLoading) ?
          <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
            <img src={loader} alt="loading..." />
          </div>
          :
          <div className="d-flex">
            <div className="w-100 row">
              <div className="col-3">
                <div className="internal-sidebar-container">
                  <ArrowBackIosNew className="back-button-sub-grower" onClick={() => (navigate('/'))} />
                  <div className='file-upload-div'>
                    <div className='internal_sidebar_header_prereg'>Frequently Asked Questions</div>
                  </div>
                </div>
              </div>

              <div class="col-9">
                <Typography sx={{ color: '#009A4E' }} variant='h5' className='brandName'>
                  <img class="img-logo-header" src={abeplLogo} alt="logo" />
                  Assam Bio Ethanol Private Limited
                  <Button variant="contained" startIcon={<FAQIcon />} onClick={() => { MyDoc() }} sx={{ marginLeft: '75%', marginBottom: '1%' }}> FAQs Download </Button>
                </Typography>
                <Grid container>
                  <Grid item xs={12}>
                    <Card className='w-100'>
                      {/* <Scrollbar> */}
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell />
                            <TableCell align="left">Catagory</TableCell>
                            <TableCell align="left">subCategory</TableCell>

                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                          ).map((row, idx) => (
                            <WorklogListnew key={idx} index={idx} row={row} />
                          ))}
                          {emptyRows > 0 && (
                            <TableRow style={{ height: 35 * emptyRows }}>
                              <TableCell colSpan={4} />
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      {/* </Scrollbar> */}
                      {rows.length > 0 && (
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 25]}
                          component="div"
                          count={rows.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          showFirstButton showLastButton
                        />)}

                    </Card>


                  </Grid>
                </Grid>
              </div>

            </div>

          </div>

      }


    </>
  )
}


export default FaqsPage